import { Tooltip } from "flowbite-react";
import { useMemo } from "react";
import { ImWarning } from "react-icons/im";
import { HiCheckCircle } from "react-icons/hi";
import { MaintenanceType } from "../../../types/maintenance.type";

export default function PendenciesMaintenance({ maintenance, placement }: { maintenance: Partial<MaintenanceType>, placement?: 'right' | 'top' | 'bottom' | 'left' }) {
  const badgeColor = useMemo(() =>
    (maintenance.pendencies?.length === 0)
      ? 'bg-greenPrimary'
      : 'bg-yellowDark'
    , [maintenance.pendencies])
  return !maintenance.pendencies?.length ? (
    <div> <HiCheckCircle className={'text-greenPrimary h-6 w-6'} /> </div>
  ) : (
    <div>
      <Tooltip content={(
        <ul>
          {maintenance.pendencies?.map(({ key, message }) =>
          (
            <li key={`key-${key}-${Date.now()}-${Math.random()}`} className="flex gap-1 items-center justify-start">
              <ImWarning className="text-yellowPrimary h-4 w-6" />
              <span> - {message}</span>
            </li>
          ))}
        </ul>
      )} placement={placement || 'right'} className={`bg-white text-black border`} trigger="click" arrow={true} >
        <button className={`rounded-full shadow-sm h-6 w-6 p-0 flex place-items-center place-content-center ${badgeColor}`}>
          {maintenance.pendencies?.length}
        </button>
      </Tooltip>
    </div>
  )
}